/* Scoped token re-point only — see AuthTextInput.module.css for why these
   land on the component's own root. Astryx paints `Link` from
   --color-text-accent. */

.link {
  --color-text-accent: var(--color-text-primary);
}
